var utils = require( './utils' );

var main_nav = ( function( $ ) {

	var $header,
		anim_speed = 400;

	var _init = function() {
		$header = $( '#header' );
		
		if ( utils.viewport_size().width >= 992 ) {
			$( '.header-navigation-wrapper' ).find( '.nav .menu-item-has-children' ).hover( _apply_overlay, _remove_overlay );
			_setup_submenu_clearfixes();
			_setup_superfish();
		} else if ( $header.hasClass( 'prospect-header' ) ) {
			_setup_prospect_header_responsive();
		}
	};

	var _setup_prospect_header_responsive = function() {
		_setup_submenus();

		$header.find( '#toggle-prospect-menu' ).on( 'click', function( e ) {
			e.preventDefault();
			_toggle_menu();
		} )
	};

	var _setup_submenus = function() {
		$header.find( '#main-nav li.menu-item-has-children > a' ).on( 'click', _toggle_submenus );
	};

	var _toggle_submenus = function ( e ) {
		e.preventDefault();

		var $item = $( this ).closest( 'li.menu-item' );

		if ( $item.hasClass( 'animating' ) ) {
			return;
		}

		$item.addClass( 'animating' );

		if ( ! $item.hasClass( 'expanded' ) ) {
			_open_submenu( $item );
		} else {
			_close_submenu( $item );
		}

		setTimeout( function() {
			$item.removeClass( 'animating' );
		}, anim_speed );

		// _close_submenu( $header.find( '#main-nav li.expanded' ).not( $( this ).parents( 'li.menu-item' ) ) );
	};

	var _close_submenu = function ( $item ) {
		$item.removeClass( 'expanded' );
		$item.find( '.sub-menu' ).slideUp( anim_speed );
	};

	var _open_submenu = function ( $item ) {
		$item.addClass( 'expanded' );
		$item.find( '.sub-menu' ).slideDown( anim_speed );
	};

	var _toggle_menu = function(  ) {
		var $menu = $( '#main-nav' );

		if ( $menu.hasClass( 'animating' ) ) {
			return;
		}

		$menu.addClass( 'animating' );

		if ( $menu.hasClass( 'open' ) ) {
			_close_menu( $menu );
		} else {
			_open_menu( $menu );
		}

		setTimeout( function() {
			$menu.removeClass( 'animating' );
		}, anim_speed );
	};

	var _open_menu = function( $menu ) {
		$header.find( '#toggle-prospect-menu' ).addClass( 'open' );
		$menu.addClass( 'open' );
		$menu.slideDown( anim_speed );
	};

	var _close_menu = function( $menu ) {
		$header.find( '#toggle-prospect-menu' ).removeClass( 'open' );
		$menu.removeClass( 'open' );
		$menu.slideUp( anim_speed );
	};

	var _setup_superfish = function() {
		$( '.header-navigation-wrapper' ).find( '.nav' ).superfish( {
			delay : 400,
			animation : { opacity : 'show', height : 'show' },
			speed : 'slow',
			autoArrows : false
		} );
	};

	var _apply_overlay = function() {
		$( '#content' ).addClass( 'menu-overlay' );
	};

	var _remove_overlay = function() {
		$( '#content' ).removeClass( 'menu-overlay' );
	};

	var _setup_submenu_clearfixes = function() {
		var $wrapper = $header.find( '.submenu-container ul.sub-menu-items.add-clearfixes' );

		$wrapper.find( 'li:nth-of-type(2n)' ).after( '<div class="clearfix"></div>' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = main_nav;